<!-- 🖥️ NAVBAR HORIZONTAL CORPORATIVO INTEGRADO -->
<nav *ngIf="authService.isAuthenticated() && !router.url.includes('/login')" class="navbar navbar-expand-lg navbar-dark bg-dark shadow mb-3 px-3">
  <div class="container-fluid">
    
    <!-- Marca del Sistema -->
    <div class="navbar-brand d-flex align-items-center gap-2 m-0 me-4 py-1" style="cursor: pointer;" routerLink="/home">
      <span class="fs-6 fw-bold text-white font-monospace" style="letter-spacing: 0.5px;">⚙️ PORTAL_ERP</span>
    </div>

    <!-- Links de Módulos (Estilo de Pestañas Modernas) -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto gap-1">
        
        <li class="nav-item">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/customers" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            👥 Clientes
          </a>
        </li>
        
        <li class="nav-item">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/unidad" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            🚗 Vehículos
          </a>
        </li>
        
        <li class="nav-item">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/recepciones" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            📋 Recepciones
          </a>
        </li>

        <li class="nav-item">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/cotizaciones" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            💰 Cotizaciones
          </a>
        </li>        

        <li class="nav-item">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/ordenesdeservicio" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            ‍🔧 Órdenes de servicio
          </a>
        </li>   

		    <!-- Inyectado en el Navbar horizontal de app.component.html -->
        <li class="nav-item" *ngIf="authService.hasRole('ROLE_ADMIN')">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/admin/udcs" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            ⚙️ Catálogos UDC
          </a>
        </li>    

        <!-- 🛡️ Filtro por rol UDC: Solo el Administrador ve el módulo de Seguridad -->
        <li class="nav-item" *ngIf="authService.hasRole('ROLE_ADMIN')">
          <a class="nav-link px-3 py-1 fw-bold text-uppercase" routerLink="/admin/users" routerLinkActive="active" style="font-size: 0.8rem; border-radius: 6px;">
            🔑 Usuarios y Seguridad
          </a>
        </li>

      </ul>

      <!-- Lado Derecho: Info del Asesor y Botón de Salida Segura -->
      <div class="d-flex align-items-center gap-3">
        <span class="text-white-50 font-monospace small bg-secondary bg-opacity-25 px-2 py-1 rounded" style="font-size: 0.75rem;">
          👤 {{ authService.getUserId() | uppercase }} (AN8: {{ authService.getAn8Asesor() }})
        </span>
        
        <button type="button" class="btn btn-sm btn-outline-danger px-3 py-1 fw-bold border-0" 
                style="font-size: 0.8rem; background-color: rgba(255,255,255,0.05); border-radius: 6px;"
                (click)="ejecutarCerrarSesion()">
          🚪 Salir
        </button>
      </div>
    </div>

  </div>
</nav>

<!-- 📥 CONTENEDOR REACTIVO DONDE ANGULAR PINTA LAS VISTAS DEL LISTADO -->
<main class="animate-fade">
  <router-outlet></router-outlet>
</main>